module.exports = __webpack_public_path__ + "static/residential-img-775c68c56ff3fe9262ab08cee1a5b5a5.jpg";